export default "__VITE_PUBLIC_ASSET__4732d154__"